<template>


	<div class='pannel_box'>

		<div class="pannel_box_row">
			<span class="pannel_title">服务类型：</span>
			<div class="pannel_select">
				<span :key="index" v-for="(item,index) in fwlx.slice(5)" @click="select(item,index)" :class="(item.status=='selected')?'pannel_option_selected':'pannel_option'">{{item.label}}</span>
			</div>
		</div>

		<div class="pannel_box_row">
			<span class="pannel_title">地区：</span>
			<div class="pannel_select">
				<span :key="index" v-for="(item,index) in dq" @click="select(item,index)" :class="(item.status=='selected')?'pannel_option_selected':'pannel_option'">{{item.label}}</span>
			</div>
		</div>
		<div class="pannel_box_row">
			<span class="pannel_title">金额：</span>
			<div class="pannel_select">

				<span :key="index" v-for="(item,index) in je" @click="select(item,index)" :class="(item.status=='selected')?'pannel_option_selected':'pannel_option'">{{item.label}}</span>

			</div>

		</div>
		<div class="pannel_box_row">
			<span class="pannel_title">筛选细节：</span>
			<div class="pannel_select" style="grid-template-columns: repeat(auto-fill,11vw);">
				<span :key="index" v-for="(item,index) in selectArray" @click="remove(item,index)" class="pannel_selected_option">{{item.label}}<span><i
						 class="iconfont">&#xe638;</i></span></span>

			</div>
		</div>

	</div>


</template>

<script>
	import {mapGetters} from 'vuex'
	import {
		getAllKind
	} from '../../api/cus.js'
	import {
		regionData
	} from 'element-china-area-data'
	import {
		queryYumiOrder
	} from '../../api/cus.js'
	export default {
		computed:{
			...mapGetters(['Query','Search'])
		},
		data() {
			return {
				//每个属性都必须带有label，value ，status,type,方便取消的时候进行查找
				// {
				// 	label:"福建",
				// 	value:"fj",
				// 	status:"none",
				// 	type:"dq",
				// }
				fwlx: [],
				dq: [],
				selectArray: [],
				je: [{
						label: "1-4k",
						value: [1000,4000],
						status: "none",
						type: "je",
					},
					{
						label: "4-10k",
						value: [4000,10000],
						status: "none",
						type: "je",
					},
					{
						label: "10-20k",
						value: [10000,20000],
						status: "none",
						type: "je",
					},


				]


			}

		},
		created() {
			getAllKind().then(res => {
				this.setFwlx(res)
				this.loadQuery()
				this.loadSearch()
			})
			this.setDq()
			this.$nextTick(()=>{
				//载入从其他页面来的查询参数
				
				
			})
			
		},
		methods: {
			loadQuery(){
				// if(this.Query.filter(item=>{if(item&&item.type=='word') return item}).length>0){
				
				// 	this.selectArray.push(this.Query.find(item=>{if(item&&item.type=='word') return item}))
				// 	this.$store.dispatch("SetQuery",this.selectArray)
				// }
				// if(this.Query.filter(item=>{if(item&&item.type=='dq') return item}).length>0){
				// 	let i = 0
				// 	for(let o  of this.dq){
						
				// 		if(o.value === this.Query.find(item=>{if(item.type=='dq') return item}).value)this.select(o, i)
				// 		i++
				// 	}
				// }
				
				console.log('[this.Query]',this.Query);
				if(this.Query.length>0&&this.Query.filter(item=>{if(item&&item.type=='fwlx') return item}).length>0){
				 let i = 0
				for(let o  of this.fwlx){
					let d = this.Query.find(item=>{if(item.type=='fwlx') return item})
					
					if(o.value === d.value){
						
						this.select(o, i)
						
					}
					i++
				}
				}
				
				
				
			},
		loadSearch(){
			console.log('[this.Search]',this.Search);
			if(this.Search.dq){
				let i = 0
				for(let o  of this.dq){
					
					if(o.label == this.Search.dq)this.select(o, i)
					i++
				
				}
			}
			
			
		},
			select(item, index) {
				//清除选中状态
				 console.log('[item]', item);
				this.clearStatus(item.type)
				this[item.type][index+5].status = 'selected'
				item.index = index
				this.selectArray.push(item)
				
				this.$store.dispatch("SetQuery",this.selectArray)
				
				
				
			},
			clearStatus(type) {
				console.log('[type]', type);
				for (var o of this[type]) o.status = 'none'

				this.selectArray = this.selectArray.filter(item => {

					if (item.type != type) return true

				})

			},
			remove(item, index) {

				this.selectArray.splice(index, 1)

				this[item.type][item.index].status = 'none'
				this.$store.dispatch("SetQuery",this.selectArray)
			},
			setDq() {

				for (var o of regionData) {

					o.status = "none"
					o.type = "dq"
					o.children = null 
					this.dq.push(o)
				}


			},
			setFwlx(res) {

				for (var o of res) {
					
					o.status = "none"
					o.type = "fwlx"
					this.fwlx.push(o)
				}

			}


		},
		
		

	}
</script>

<style>
	.pannel_box {
		padding-top: 2vw;
		margin-left: 10.667vw;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		width: 78.646vw;
		min-height: 19.792vw;
		background-color: #ffffff;
		box-shadow: 0vw 0vw 0.469vw 0vw rgba(0, 0, 0, 0.15);


	}

	.pannel_box_row {
		min-height: 5.365vw;
		padding-left: 2.604vw;
		border-bottom: #ccd4de solid 1px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding-bottom: 1vw;

	}

	.pannel_title {
		width: 6vw;
		font-family: SourceHanSansCN-Regular;
		font-size: 1.042vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 2.813vw;
		letter-spacing: 0vw;
		color: #9d9d9d;
	}

	.pannel_option {
		font-family: SourceHanSansCN-Regular;
		font-size: 1.042vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 2.813vw;
		letter-spacing: 0vw;
		color: #4c4948;

	}

	.pannel_option_selected {
		font-family: SourceHanSansCN-Regular;
		font-size: 1.042vw;
		font-weight: normal;
		font-stretch: normal;
		line-height: 2.813vw;
		letter-spacing: 0vw;
		color: #4c4948;
		background-color: #eff4f9;
		color: #409be8;

	}

	.pannel_select {
		display: grid;
		width: 63.54vw;
		grid-template-columns: repeat(auto-fill, 11vw);
		grid-template-rows: auto;
		grid-column-gap: 2vw;



	}

	.pannel_select>span:hover {

		background-color: #eff4f9;
transition: all 0.25s ease-in-out;
	}

	.pannel_selected_option {
		width: auto;
		height: 2.135vw;
		background-color: #ffffff;
		border-radius: 1.068vw;
		border: solid 0.052vw #409be8;
		margin-left: 1vw;
		margin-right: 1vw;
		color: #409be8;
		font-size: 0.8vw;
		line-height: 2.135vw;
	}
</style>
